import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { Document } from 'store/types/Meeting';

interface DocumentViewCardProps {
  document: Document;
}

const DocumentViewCard: React.FunctionComponent<DocumentViewCardProps> = ({ document }) => {
  return (
    <GridContainer>
      <GridItem>
        <Card title={<Typography variant="h6">Document</Typography>} bordered>
          <GridContainer spacing={1}>
            <GridItem md={2}>
              <Typography>
                <strong>Document Number:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{document.number}</Typography>
            </GridItem>

            <GridItem md={2}>
              <Typography>
                <strong>Document Title:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{document.title}</Typography>
            </GridItem>

            {(document.lineItemNumber || document.lineItemTitle) && (
              <>
                <GridItem md={2}>
                  <Typography>
                    <strong>Line Item Number:</strong>
                  </Typography>
                </GridItem>
                <GridItem md={10}>
                  <Typography>{document.lineItemNumber}</Typography>
                </GridItem>

                <GridItem md={2}>
                  <Typography>
                    <strong>Line Item Title:</strong>
                  </Typography>
                </GridItem>
                <GridItem md={10}>
                  <Typography>{document.lineItemTitle}</Typography>
                </GridItem>
              </>
            )}
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default DocumentViewCard;
